import { useGAPageView } from '../hooks/useGAPageView';

const GaTracker = () => {
  useGAPageView();
  return null; // 이 컴포넌트는 UI를 렌더링하지 않습니다.
};

export default GaTracker;

